import Dialog from 'components/ReusableComponents/Dialog'
import { Redirect, useLocation } from 'react-router'

import desktopImage from './desktop-illustration.png'
import styles from './Go.module.scss'

//const supportedPlatforms = ['Windows NT 10.0', 'Mac OS X 10']
//const supportedPlatforms = ['Windows NT 10.0']
const supportedPlatforms = []

const Go = () => {
  let location = useLocation()
  const pathToGo = location.pathname.match(/^\/go(\/.+)$/)[1]

  if (supportedPlatforms.some(os => navigator.userAgent.includes(os))) {
    return (
      <Dialog>
        <div className={styles.openInAppDialog}>
          <figure
            className={styles.topFigure}
            style={{ backgroundImage: `url(${desktopImage})` }}
          ></figure>
          <div className={styles.content}>
            <a href={`swaypay://dashboard${pathToGo}`}>
              <button className={styles.cta}>Open this page on Directful app</button>
            </a>
            <p className={styles.noAppText}>
              Don't have the app?{' '}
              <a href="https://directful.com/download">Download Directful for Windows</a>
            </p>
          </div>
        </div>
      </Dialog>
    )
  } else {
    return <Redirect to={pathToGo} />
  }
}

export default Go
